import CardContainer from 'src/components/CardContainer/CardContainer';
import { IntegrationsModal } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationsModal';
import { CurrentIntegrationField } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegrationField';
import { clsx } from 'clsx';
import { useGetProjectByIdQuery } from 'src/services';
import { useParams } from 'react-router-dom';
import { useAppSelector } from 'src/store';
import { ProjectStatusBadge } from 'src/pages/ControlDeskPage/ProjectTitle/ProjectStatusBadge';

export const IntegrationStatusSection = () => {
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { id } = useParams();

  const { data: currentProject } = useGetProjectByIdQuery({ id: id });

  return (
    <CardContainer className="integration !h-full">
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-header z-50',
        )}
      >
        <div className="title cursor-default">
          <span className="!no-underline max-md:hidden text-sm font-bold text-[#7A6BE5]">
            AI Agent Status
          </span>
          <ProjectStatusBadge />
        </div>
        <div className="relative flex md:gap-2.5 gap-2 items-center">
          <div className="add-button-container relative flex md:gap-2.5 gap-2">
            <IntegrationsModal visible={!currentProject?.integrations?.length} />
          </div>
        </div>
      </div>
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-body flex w-full gap-2.5 max-md:flex-col !mt-[17px]',
        )}
      >
        <CurrentIntegrationField />
      </div>
    </CardContainer>
  );
};
